export function ingredientCheckerAccessNotice(state) {
  if (state.loadingKits) return 'Loading your test kits';
  if (state.kitsError) return 'Unable to load your test kits';
  if (!state.kitId) return state.kits.length
    ? 'Select a kit to check plan access' : 'No completed test kits available';
  if (state.entitlementLoading) return 'Checking plan access';
  if (state.entitlementError) return 'Plan access could not be checked';
  if (!state.entitlementLoaded) return 'Plan access has not been checked';
  const access = state.entitlement;
  if (access.hasFreeIngredientChecker) return access.activeKitEntitlement?.displayLabel
    || 'Free Ingredient Checker active for this kit';
  if (access.hasSubscription) return 'Subscription active';
  if (access.needsBillingAttention) return 'Subscription needs billing attention';
  if (access.freeChecksRemaining > 0) return 'First ingredient check included';
  return 'Subscription required to continue';
}

export async function loadIngredientCheckerAccess(state, kitId, request) {
  const requestId = ++state.entitlementRequestId;
  state.entitlementLoaded = false;
  state.entitlementError = '';
  state.entitlementLoading = Boolean(kitId);
  if (!kitId) return;
  const isCurrent = () => requestId === state.entitlementRequestId
    && String(state.kitId) === String(kitId);
  try {
    const { data } = await request(kitId);
    if (!isCurrent()) return;
    state.entitlement = {
      completedChecks: Number(data.completed_checks || 0),
      freeChecksIncluded: Number(data.free_checks_included ?? 1),
      freeChecksRemaining: Number(data.free_checks_remaining || 0),
      hasSubscription: Boolean(data.has_subscription),
      needsBillingAttention: Boolean(data.needs_billing_attention),
      canScan: Boolean(data.can_scan),
      hasFreeIngredientChecker: Boolean(data.has_free_ingredient_checker),
      activeKitEntitlement: data.active_kit_entitlement || null,
      subscriptionEnabled: data.subscription_enabled,
    };
    state.entitlementLoaded = true;
  } catch {
    if (isCurrent()) state.entitlementError = 'We could not check plan access. Please retry. Your photos are still selected.';
  } finally {
    if (isCurrent()) state.entitlementLoading = false;
  }
}
